export default {
  back: {
    cursor: 'pointer'
  }
};